module.exports = __webpack_public_path__ + "static/media/header_logo_pf.08c65e3b.svg";